export var INVALID_PHONE_MESSAGE = 'Ошибка в номере телефона';
export var INVALID_TIME_MESSAGE = 'Некорректное время';
export var RECOMMENDATIONS_SUCCESS_MESSAGE = 'По другим ЖК перезвонят чуть позже';